import { METHOD } from './method'

export const API_SYNC_PRODUCT = {
    CHECK: {
        api: '/v1/dashboard-admin/product/sync',
        method: METHOD.GET,
    },
    SYNC: {
        api: '/v1/dashboard-admin/product/sync',
        method: METHOD.POST,
    },
}
